import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { updatePropertyAddress } from 'services/api/property-api.service';
import { QueryKey } from 'common/enums/query-key';
import { CreateRentEstateRequest } from 'common/generated/types/create-rent-estate-request';

export default function useUpdatePropertyAddress(
  options?: Omit<UseMutationOptions<string, Error, CreateRentEstateRequest & { id: string }, unknown>, 'mutationFn'>,
) {
  return useMutation({
    mutationFn: updatePropertyAddress,
    mutationKey: [QueryKey.PropertyAddress],
    ...options,
  });
}
